
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import cuentas from './lista-buscador-cuentas.vue';
    import seleccion from './lista-buscador-seleccion.vue';
    import filtros from './lista-buscador-filtros.vue';
    import listados from './lista-buscador-listados.vue';
    import sincronizacion from './lista-buscador-sincronizacion.vue';
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            filtros,
            cuentas,
            seleccion,
            listados,
            sincronizacion,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }


        public Busqueda: string = '';
        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
            this.Buscador.Filtros.Busqueda = this.Busqueda;
            this.Buscador.Buscar( 1 );
        }
    }
